import React, {memo} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

function HeaderNavItem({
  route, text, isActive, onClick, className, isDisabled,
}) {
  return (
    <li className="top-nav_item">
      {route && (
        <Link
          to={route}
          className={`top-nav_link ${className} ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
        >
          {text}
        </Link>
      )}
      {!route && (
        <span
          role="button"
          onClick={onClick}
          className={`top-nav_link ${className} ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
        >
          {text}
        </span>
      )}
    </li>
  );
}

HeaderNavItem.defaultProps = {
  route: '',
  text: '',
  className: '',
  onClick: () => {},
  isActive: false,
  isDisabled: false,
};

HeaderNavItem.propTypes = {
  route: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default memo(HeaderNavItem);
